import { CustomInputMapping } from "../../../redux/data/globalData/customInputMapping/customInputMappingActions";

export const getCustomInput = (dataType: string, customInputs: CustomInputMapping[]): CustomInputMapping | undefined => {
    const mapping = customInputs.find(input => input.customDataMapping.dataTypeFilter === dataType);

    return mapping;
}